import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const SchoolCounsellor = () => {
    useEffect(() => {
        document.title = 'School Counsellor -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>School Counsellor</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Counsellor </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                <p>The School has a counsellor who is available for consultation and counselling on all the weekdays. The counsellor will be conducting the following activities:</p>
                <ul className="list"> 
            <li> Identification of various behavioural, emotional, academic and psychological problems.screening and treatment of children with problems like Specific Learning Disabilities (SLD), Attention Deficit Hyperactivity Disorder (ADHD), Oppositional Defiant Disorder (ODD) and Mental Retardation (MR).
            </li>
            <li> I Q Testing, Aptitude and Personality Tests. Career Guidance.
            </li>
            <li> Sex Education.
            </li>
            <li> Life Skill Training Communication Skills, Assertiveness Training, Empathy, Time Management, Stress Management and Personality Enhancement will be the areas of focus.
            </li>
            <li> Workshops for parents and children on various areas of Mental Health. </li>
            </ul>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-xl-3 col-lg-4 col-md-6">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
              <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/SchoolCounsellor3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
            </LazyLoad>  
             </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default SchoolCounsellor